import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllAcademicYears as apiForceDeleteAll } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllAcademicYears() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAllAcademicYears, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiForceDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicYears"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAllAcademicYears, isForceDelete };
}
